/** 수집 기준(스케줄) — 공고 화면과 수집·알림 화면이 함께 쓴다. */
export interface Schedule {
  id: number;
  name: string;
  keywords: string | null;
  institution: string | null;

  /* 2026-09-27 에 DB 컬럼이 생겼다 (consult_bid_schedules).
     그 전에는 목데이터로만 채워져 저장이 안 됐다. */
  excludeKeywords?: string | null;
  bizDiv?: string | null;
  classification?: string | null;
  minPrice?: number | null;
  maxPrice?: number | null;
  license?: string | null;

  cronExpression: string;
  emailTo: string;
  isActive: boolean;
  lastRunAt: string | null;
  createdAt: string;
  creator?: { name: string };
}

export interface EmailLog {
  id: number;
  bidCount: number;
  emailTo: string;
  status: string;
  errorMessage: string | null;
  sentAt: string;
}

export interface ScheduleForm {
  name: string;
  keywords: string;
  institution: string;
  cronExpression: string;
  emailTo: string;
  excludeKeywords: string;
  bizDiv: string;
  classification: string;
  minPrice: number | null;
  maxPrice: number | null;
  license: string;
}

/** 나라장터는 업무구분을 응답 필드가 아니라 엔드포인트로 나눈다 */
export const BIZ_DIVS = [
  { label: '용역', value: '용역', endpoint: 'getBidPblancListInfoServc' },
  { label: '물품', value: '물품', endpoint: 'getBidPblancListInfoThng' },
  { label: '공사', value: '공사', endpoint: 'getBidPblancListInfoCnstwk' },
];

/** 응답의 pubPrcrmntLrgClsfcNm — 2026-09-01~20 공고 8,052건에서 실제로 나온 값 */
export const CLASSIFICATIONS = [
  '행사관리 및 기타 사업 지원서비스',
  '연구조사서비스',
  'ICT 서비스',
  '폐기물 처리 및 재활용서비스',
  '교육 및 전문직종/기술서비스',
  '여행*숙박*음식*운송 및 보험서비스',
  '임대*위탁 및 수리서비스',
  '시설물관리 및 청소서비스',
  '매체제작, 디자인, 홍보/마케팅 서비스',
  '정보통신방송서비스',
];

/** 추정가격 눈금 — 같은 기간 표본의 분포에서 잡았다 (중앙값 7,272만) */
export const PRICE_STEPS = [
  { label: '3천만', value: 30_000_000 },
  { label: '1억', value: 100_000_000 },
  { label: '3억', value: 300_000_000 },
  { label: '10억', value: 1_000_000_000 },
];

export function formatPrice(v: number | null | undefined): string {
  if (v == null) return '';
  if (v >= 100_000_000) return `${v / 100_000_000}억`;
  if (v >= 10_000) return `${(v / 10_000).toLocaleString()}만`;
  return v.toLocaleString();
}

export const CRON_PRESETS = [
  { label: '매일 10시, 17시', value: '0 10,17 * * *' },
  { label: '매일 9시', value: '0 9 * * *' },
  { label: '매일 10시', value: '0 10 * * *' },
  { label: '평일 10시, 17시', value: '0 10,17 * * 1-5' },
  { label: '평일 09~20시 매시 정각', value: '0 9-20 * * 1-5' },
  { label: '매시 정각', value: '0 * * * *' },
];

export const emptyForm: ScheduleForm = {
  name: '',
  keywords: '',
  institution: '',
  cronExpression: '0 10,17 * * *',
  emailTo: '',
  excludeKeywords: '',
  bizDiv: '용역',
  classification: '',
  minPrice: null,
  maxPrice: null,
  license: '',
};

export function formatCron(cron: string): string {
  return CRON_PRESETS.find((p) => p.value === cron)?.label ?? cron;
}

export function formatDate(dt: string | null): string {
  if (!dt) return '-';
  return new Date(dt).toLocaleString('ko-KR');
}
